import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Projects.css';
import { PROJECT_VIDEOS as videos } from '../data/projectVideos';
import type { ProjectVideo as Video } from '../data/projectVideos';


interface VideoModalProps {
  video: Video;
  onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ video, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { t } = useTranslation();

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="video-modal-header">
          <h3>{t(`projects.videos.${video.key}.title`)}</h3>
          <button className="video-modal-close" onClick={onClose}>✕</button>
        </div>
        <video
          ref={videoRef}
          className="video-modal-player"
          controls
          autoPlay
          playsInline
          src={video.videoUrl}
        />
      </div>
    </div>
  );
};

const Projects: React.FC = () => {
  const [activeVideo, setActiveVideo] = useState<number | null>(null);
  const { t } = useTranslation();

  return (
    <div className="projects-page">
      <div className="projects-hero">
        <div className="projects-header">
          <span className="projects-badge">{t('projects.badge')}</span>
          <h1 className="projects-title">{t('projects.title')}</h1>
          <p className="projects-subtitle">
            {t('projects.subtitle')}
          </p>
        </div>
      </div>

      <div className="projects-grid">
        {videos.map((video, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => setActiveVideo(index)}
          >
            <div className="project-thumbnail">
              {video.thumb ? (
                <img className="thumbnail-video" src={video.thumb} alt={t(`projects.videos.${video.key}.title`)} loading="lazy" />
              ) : (
                <video
                  className="thumbnail-video"
                  src={video.videoUrl}
                  muted
                  playsInline
                  preload="metadata"
                />
              )}
              <div className="thumbnail-overlay">
                <div className="play-btn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="project-info">
              <span className="project-index">0{index + 1}</span>
              <div>
                <h3 className="project-title">{t(`projects.videos.${video.key}.title`)}</h3>
                <p className="project-description">{t(`projects.videos.${video.key}.description`)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {activeVideo !== null && (
        <VideoModal
          video={videos[activeVideo]}
          onClose={() => setActiveVideo(null)}
        />
      )}
    </div>
  );
};

export default Projects;
